import RecordsOnTable from './RecordsOnTable';

export default RecordsOnTable;
